// Core Module: Handles variant change detection and calls other modules

// Function to get the variant ID from the URL
function getVariantIdFromUrl() {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant');
}

// Function to handle variant change for fabric variant
function handleFabricVariantChange() {
  const variantId = getVariantIdFromUrl();  // Get the current variant ID from URL
  if (variantId) {
    updateVariantImages(variantId);  // Call to Variant Images Module
    updateStyleImage(variantId);     // Call to Style Images Module
    updateThreadImages(variantId);   // Call to Thread Images Module
  }
}

// Main document ready function
jQuery(document).ready(function($) {
  // Event listener for clicks on fabric variant swatches
  $('.fabricVariant .option-item-inner').on('click', function() {
    $('.fabricVariant .option-item-inner').removeClass('selected');
    $(this).addClass('selected');
    handleFabricVariantChange();  // Trigger the variant change
  });

  // Event listener for clicks on style selection
// $('.styleSwatches .option-item-inner').on('click', function() {
//   $('.styleSwatches .option-item-inner').removeClass('selected');
//   $(this).addClass('selected');

//   // Attempt to get the option-value by checking if it's within this element or nested inside
//   const optionValue = $(this).attr('option-value') || $(this).closest('.option-item-inner').attr('option-value') || $(this).find('[option-value]').attr('option-value');
//   console.log("Selected style option-value:", optionValue);

//   // Update the text in .styleTitleVariant p with the optionValue
//   $('.styleTitleVariant p').text(optionValue);

//   handleFabricVariantChange();  // Trigger the style change

//   // Trigger click on the first button inside .mobileCarousel .gp-carousel-dot-container after 250ms delay
//   setTimeout(function() {
//     $('.mobileCarousel .gp-carousel-dot-container button').eq(0).click();
//     $('.styleSwatches .gp-items-start legend').addClass("styleVariantTitleFix");
//   }, 250);
// });

// Event listener for clicks on style selection
$('.styleSwatches .option-item-inner').on('click', function() {
  // Remove 'selected' class from all style swatches
  $('.styleSwatches .option-item-inner').removeClass('selected');
  $(this).addClass('selected');

  // Attempt to get the option-value by checking if it's within this element or nested inside
  const optionValue = $(this).attr('option-value') || 
                      $(this).closest('.option-item-inner').attr('option-value') || 
                      $(this).find('[option-value]').attr('option-value');
  console.log("Selected style option-value:", optionValue);

  // Remove 'styleTitleSelected' class from all <p> elements in 'styleSelectRow'
  $(".styleSelectRow p").removeClass("styleTitleSelected");

  // Add 'styleTitleSelected' to the <p> element matching the optionValue
  $(".styleSelectRow p").filter(function() {
    return $(this).text().trim() === optionValue;
  }).addClass("styleTitleSelected");

  // Update the text in .styleTitleVariant p with the optionValue
  $('.styleTitleVariant p').text(optionValue);

  // Trigger the fabric variant change function
  handleFabricVariantChange();

  // Trigger click on the first button inside .mobileCarousel .gp-carousel-dot-container after 250ms delay
  setTimeout(function() {
    $('.mobileCarousel .gp-carousel-dot-container button').eq(0).click();
    $('.styleSwatches .gp-items-start legend').addClass("styleVariantTitleFix");
  }, 250);
});




  // Assign the thread color click event after delay (to ensure elements are rendered)
  // setTimeout(function() {
  //   $(".bold_options .bold_option_value_element").on('mouseup', function() {
  //     threadChange();  // Call the Thread Images Module when a thread swatch is clicked
  //   });
  // }, 250); // Delay to ensure elements are loaded

  setTimeout(function() {
    $(".bold_options .bold_option_value_element").on('mouseup', function() {
      let $this = $(this);
  
      // If this swatch is already selected, trigger another click after 250ms
      if ($this.hasClass("bold_swatch_selected")) {
        console.log("Thread swatch already selected. Triggering another click to prevent deselect...");
        setTimeout(() => {
          $this.trigger("click");
        }, 250);
      }
    });
  }, 250);




  // Load initial data if variant is already selected (on page load)
  const initialVariantId = getVariantIdFromUrl();
  if (initialVariantId) {
    updateVariantImages(initialVariantId);  // Load variant images on page load
    updateStyleImage(initialVariantId);     // Load style images on page load
    updateThreadImages(initialVariantId);   // Load thread images on page load
  }
});


// BEGIN THREAD MODULE***********************************************************************
// Thread Images Module: Handles thread image changes and updates

// Thread Change function
function threadChange() {
    console.log("Thread change event triggered");

    // Get the clicked color value from the child input
    const selectedColor = $(event.target).closest('.bold_option_value_element').find('input[type="checkbox"]').val().trim();
    console.log('Selected color:', selectedColor);

    // Display the selected thread color with a colon and space prefix
    $('.pdp2024 .prodThreadSpools .selectedThreadName').text(": " + selectedColor);

    // Get the variant ID from the URL
    const variantId = getVariantIdFromUrl();

    if (variantId) {
        // Fetch the thread_colors metafield for the variant
        fetchThreadColors(variantId, selectedColor);
    } else {
        console.log('Variant ID not found in URL.');
    }

    // Trigger click on the second button inside .mobileCarousel .gp-carousel-dot-container
     // Trigger click on the first button inside .mobileCarousel .gp-carousel-dot-container after 750ms delay
    setTimeout(function() {
       $('.mobileCarousel .gp-carousel-dot-container button').eq(1).click();
    }, 250); // 750ms delay
    
}


// Function to update thread images
function updateThreadImages(variantId) {
  const selectedCheckbox = $('.bold_option_value_element input[type="checkbox"]:checked');
  
  if (selectedCheckbox.length > 0) {
    const selectedColor = selectedCheckbox.val();  // Get the value
    fetchThreadColors(variantId, selectedColor.trim());  // Fetch thread images
  } else {
    console.log('No thread color selected, using default color Baby Blue.');
    fetchThreadColors(variantId, 'Navy');  // Default fallback to Baby Blue
  }
}

// Function to fetch and display thread images
function fetchThreadColors(variantId, selectedColor) {
  const storefrontAccessToken = '467c76bf7b9f52672e21403f810e9de3';  // Replace with your actual token
  const shopName = 'blue-delta-jeans';  // Replace with your shop's name

  console.log('Fetching thread colors for variant:', variantId);

  const query = `
    {
      node(id: "gid://shopify/ProductVariant/${variantId}") {
        ... on ProductVariant {
          metafield(namespace: "custom", key: "thread_colors") {
            value
          }
        }
      }
    }
  `;

  fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query })
  })
  .then(response => response.json())
  .then(data => {
    const threadColorsMetafield = data.data.node.metafield;
    if (threadColorsMetafield && threadColorsMetafield.value) {
      const threadColorsGIDs = JSON.parse(threadColorsMetafield.value);
      fetchAndDisplayThreadImages(threadColorsGIDs, selectedColor);
    } else {
      console.log('No thread colors metafield found.');
    }
  })
  .catch(error => {
    console.log('Error fetching thread colors metafield:', error);
  });
}

// Function to display thread images
function fetchAndDisplayThreadImages(mediaGIDs, selectedColor) {
  const storefrontAccessToken = '467c76bf7b9f52672e21403f810e9de3';  // Replace with your actual token
  const shopName = 'blue-delta-jeans';  // Replace with your shop's name

  const query = `
    {
      nodes(ids: ${JSON.stringify(mediaGIDs)}) {
        ... on MediaImage {
          image {
            url
          }
        }
      }
    }
  `;

  fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query })
  })
  .then(response => response.json())
  .then(data => {
    let matchingUrl = null;
    const normalizedColor = selectedColor.replace(/\s+/g, '').toLowerCase();

    data.data.nodes.forEach(function(mediaNode) {
      if (mediaNode && mediaNode.image && mediaNode.image.url) {
        const filename = mediaNode.image.url.split('/').pop().toLowerCase();
        if (filename.includes(normalizedColor)) {
          matchingUrl = mediaNode.image.url;
        }
      }
    });

    if (matchingUrl) {
      console.log(`Thread image found: ${matchingUrl}`);
      
      // Fade out with opacity, preload new image, and show spinner
      $('.threadChangeImg img').animate({ opacity: 0 }, 200, function() {
          const imgElement = $(this);
          const spinner = $('<div class="spinner-preloader"></div>'); // Create spinner preloader
          
          // Append spinner to the container and position it
          imgElement.parent().css('position', 'relative').append(spinner);

          // Preload the new image
          const tempImg = new Image();
          tempImg.src = matchingUrl;

          tempImg.onload = function() {
              // Once loaded, update src, remove spinner, and fade in
              imgElement.attr('src', matchingUrl);
              spinner.remove();
              imgElement.animate({ opacity: 1 }, 200); // Smooth fade-in
          };
      });






      

    } else {
      console.log('No matching image URL found for thread color:', normalizedColor);
    }
  })
  .catch(error => {
    console.log('Error fetching thread media URLs:', error);
  });
}


// Assign the thread change listener
function assignClickListener() {
  $(".bold_options .bold_option_value_element").attr("onmouseup", "threadChange()");
}

// Bind the thread change function after a delay to ensure the elements are loaded
jQuery(document).ready(function($) {
  setTimeout(assignClickListener, 1500);  // Delay to ensure all elements are fully loaded
});






// BEGIN LIFESTYLE/VARIANT IMAGES MODULE********************************************************************

// Variant Images Module: Handles variant image changes and updates

// Function to update variant images in the container
function updateVariantImages(variantId) {
  const storefrontAccessToken = '467c76bf7b9f52672e21403f810e9de3';  // Replace with your actual token
  const shopName = 'blue-delta-jeans';  // Replace with your shop's name

  console.log("Fetching variant images for variant:", variantId);

  const query = `
    {
      node(id: "gid://shopify/ProductVariant/${variantId}") {
        ... on ProductVariant {
          metafield(namespace: "custom", key: "variant_media") {
            value
          }
        }
      }
    }
  `;

  fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query })
  })
  .then(response => response.json())
  .then(data => {
    const variantMediaMetafield = data.data.node.metafield;
    if (variantMediaMetafield && variantMediaMetafield.value) {
      const mediaGIDs = JSON.parse(variantMediaMetafield.value);
      fetchAndDisplayVariantImages(mediaGIDs);
    } else {
      console.log('No variant media metafield found.');
    }
  })
  .catch(error => {
    console.log('Error fetching variant media metafield:', error);
  });
}

// Function to display variant images
function fetchAndDisplayVariantImages(mediaGIDs) {
  const storefrontAccessToken = '467c76bf7b9f52672e21403f810e9de3';  // Replace with your actual token
  const shopName = 'blue-delta-jeans';  // Replace with your shop's name

  const query = `
    {
      nodes(ids: ${JSON.stringify(mediaGIDs)}) {
        ... on MediaImage {
          image {
            url
          }
        }
      }
    }
  `;

  fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query })
  })
  .then(response => response.json())
  .then(data => {
    // Assuming we only want the first two images in the response
    const images = data.data.nodes.slice(0, 2); // Limit to two images

    if (images[0] && images[0].image && images[0].image.url) {
      const firstImageUrl = images[0].image.url;
      $('.pdp2024 .varImage1 img').attr('src', firstImageUrl);
    }

    if (images[1] && images[1].image && images[1].image.url) {
      const secondImageUrl = images[1].image.url;
      $('.pdp2024 .varImage2 img').attr('src', secondImageUrl);
    }
  })
  .catch(error => {
    console.log('Error fetching media URLs:', error);
  });
}








// BEGIN STYLE IMAGES MODULE********************************************************************

// Function to update the style image based on the variant
function updateStyleImage(variantId) {
  const storefrontAccessToken = '467c76bf7b9f52672e21403f810e9de3'; // Replace with your actual token
  const shopName = 'blue-delta-jeans'; // Replace with your shop's name

  console.log("Fetching style image for variant:", variantId);

  const query = `
    {
      node(id: "gid://shopify/ProductVariant/${variantId}") {
        ... on ProductVariant {
          title
          metafield(namespace: "custom", key: "style_media") {
            value
          }
        }
      }
    }
  `;

  fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query })
  })
    .then(response => response.json())
    .then(data => {
      const styleMediaMetafield = data.data.node.metafield;
      const variantTitle = data.data.node.title;

      // Extract the first word of the title for the style (e.g., 'Fashion' from 'Fashion Boot / Dark Indigo')
      const extractedStyle = variantTitle.split(' ')[0].trim().toLowerCase();
      console.log(`Extracted style from title: ${extractedStyle}`);

      if (styleMediaMetafield && styleMediaMetafield.value) {
        const mediaGIDs = JSON.parse(styleMediaMetafield.value);
        fetchAndDisplayStyleImage(mediaGIDs, extractedStyle);
      } else {
        console.log('No style media metafield found.');
      }
    })
    .catch(error => {
      console.log('Error fetching style media metafield:', error);
    });
}

// Function to display style image
function fetchAndDisplayStyleImage(mediaGIDs, extractedStyle) {
  const storefrontAccessToken = '467c76bf7b9f52672e21403f810e9de3'; // Replace with your actual token
  const shopName = 'blue-delta-jeans'; // Replace with your shop's name

  const query = `
    {
      nodes(ids: ${JSON.stringify(mediaGIDs)}) {
        ... on MediaImage {
          image {
            url
          }
        }
      }
    }
  `;

  fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query })
  })
    .then(response => response.json())
    .then(data => {
      let matchingUrl = null;

      data.data.nodes.forEach(function(mediaNode) {
        if (mediaNode && mediaNode.image && mediaNode.image.url) {
          const filename = mediaNode.image.url.split('/').pop().toLowerCase();
          if (filename.includes(extractedStyle)) {
            matchingUrl = mediaNode.image.url;
          }
        }
      });

      if (matchingUrl) {
        console.log(`Matched image URL: ${matchingUrl}`);
        $('.styleChangeImg img').attr('src', matchingUrl);
      } else {
        console.log(`No matching image URL found for style: ${extractedStyle}`);
      }
    })
    .catch(error => {
      console.log('Error fetching style media URLs:', error);
    });
}





// Run only once on page load
jQuery(window).on('load', function() {
  console.log("Page loaded. Checking for variant ID...");

  setTimeout(function() {
    const variantId = getVariantIdFromUrl();
    console.log("Variant ID found in URL:", variantId);

    if (!variantId) {
      console.log("No variant ID found. Attempting to trigger click on the first fabric swatch.");
      
      const firstFabricSwatch = $('.fabricVariant .option-item-inner div').first();
      
      if (firstFabricSwatch.length > 0) {
        console.log("First fabric swatch element found. Triggering click event.");
        firstFabricSwatch.trigger('click'); // Trigger the click event

        // Directly call the function to handle the fabric variant change
        handleFabricVariantChange();
      } else {
        console.log("First fabric swatch element not found.");
      }
    } else {
      console.log("Variant ID exists; no click triggered.");
    }

  }, 750); // 3-second delay
});




// SET STYLE VARIANT TEXT

// SET STYLE VARIANT TEXT

// Function to get the style for a variant ID
function setStyleTitleOnPageLoad() {
  const variantId = getVariantIdFromUrl(); // Retrieve variant ID from URL
  
  if (variantId) {
    console.log("Variant ID found on page load:", variantId);

    // Query Shopify API to get the style title for the variant
    const storefrontAccessToken = '467c76bf7b9f52672e21403f810e9de3'; // Replace with your token
    const shopName = 'blue-delta-jeans'; // Replace with your shop name

    const query = `
      {
        node(id: "gid://shopify/ProductVariant/${variantId}") {
          ... on ProductVariant {
            title
          }
        }
      }
    `;

    fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken
      },
      body: JSON.stringify({ query })
    })
    .then(response => response.json())
    .then(data => {
      const variantTitle = data.data.node.title;

      // Extract the style from the variant title
      const extractedStyle = variantTitle.split(' ')[0]; // Adjust if style naming varies
      console.log("Extracted style on page load:", extractedStyle);

      // 1. Set the style title in .styleTitleVariant p
      $('.styleTitleVariant p').text(extractedStyle);

      // 2. Add 'styleTitleSelected' to the <p> element matching the extractedStyle
      $(".styleSelectRow p").filter(function() {
        return $(this).text().trim() === extractedStyle;
      }).addClass("styleTitleSelected"); // <-- INTEGRATED HERE

    })
    .catch(error => {
      console.log("Error fetching variant style on page load:", error);
    });
  } else {
    console.log("No variant ID found on page load.");
  }
}



// Call this function on page load
jQuery(document).ready(function() {
  setStyleTitleOnPageLoad(); // Run the function to set style title if variant ID exists
});
